import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AlertContext from '../../../../context/AlertContext';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_08 = () => {
  const dispatch = useDispatch();
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  const { ntsResult } = useSelector(state => state.eDocuments);
  const [tableData01, setTableData01] = useState([]);

  useEffect(() => {
    createTableData();
  }, []);

  const createTableData = async () => {
    try {
      const resultAPI = await dispatch(getPDFApply({ htmPCd: '8' })).unwrap();
      if (resultAPI != undefined) {
        if (resultAPI.list != undefined) {
          let _tableData01 = [];
          resultAPI.list.map((item, index) => {
            if (index == 0 && item.htmMm2 == undefined) {
              _tableData01[0] = {
                htmMm2: '연말정산',
                htm005: item.htm003,
                htm006: item.htm004,
                htm007: '',
                htm008: '',
              };
              _tableData01[1] = {
                htmMm2: '합계',
                htm005: item.htm005,
                htm006: item.htm006,
                htm007: item.htm007,
                htm008: item.htm008,
              };
              _tableData01[2] = {
                htmMm2: '총합계',
                total: item.htm001,
              };
            } else {
              _tableData01.push(item);
            }
          });
          setTableData01(_tableData01);
        }
      } else {
        alertMessage('데이터가 없습니다. ', 'error');
      }
    } catch (e) {
      alertMessage('오류가 발생하였습니다. ', 'error');
    } finally {
      // setBackDrop(false);
    }
  };

  const headList = [
    { key: 'htmMm2', width: '10%' }, // 월별
    { key: 'htm005', width: '22.5%' }, // 건강보험료①
    { key: 'htm006', width: '22.5%' }, // 장기요양보험료②
    { key: 'htm007', width: '22.5%' }, // 건강보험료③
    { key: 'htm008', width: '22.5%' }, // 장기요양보험료④
  ];

  const subHeadStyled = {
    width: '165px',
    border: '1px solid #dddddd',
    borderLeft: 'none',
    padding: '10px 8px',
    textAlign: 'center',
  };

  return (
    <>
      <div className={'yearendManualContentsBox'}>
        <div className={'ntsResultBox'}>
          <p className={'body2Bold subPoint3 ntsResultTitle'}>건강보험료</p>
          <div>
            <div className="displayFlex tableTr">
              <div className="tableTitle captionBold" style={{ width: '10%', flex: 'none' }}>
                월별
              </div>
              <div style={{ width: '45%' }}>
                <div className="displayFlex tableTr">
                  <div
                    className="tableTitle captionBold"
                    style={{ borderRight: 'none', borderBottom: 'none' }}>
                    보수월액(고지금액)
                  </div>
                </div>
                <div className="displayFlex tableTr">
                  <div className="tableTitle captionBold">건강보험료①</div>
                  <div className="tableTitle captionBold" style={{ borderRight: 'none' }}>
                    장기요양보험료②
                  </div>
                </div>
              </div>
              <div style={{ width: '45%' }}>
                <div className="displayFlex tableTr">
                  <div className="tableTitle captionBold" style={{ borderBottom: 'none' }}>
                    소득월액(납부금액)
                  </div>
                </div>
                <div className="displayFlex tableTr">
                  <div className="tableTitle captionBold" style={{}}>
                    건강보험료③
                  </div>
                  <div className="tableTitle captionBold" style={{}}>
                    장기요양보험료④
                  </div>
                </div>
              </div>
            </div>
            {tableData01.map((item, index) =>
              index != 2 ? (
                <div className="displayFlex tableTr" key={index}>
                  {headList.map((_item, _index) => (
                    <div
                      className="tableBody captionMedium"
                      key={_index}
                      style={{
                        width: _item.width,
                        flex: 'none',
                        justifyContent: _item.align,
                      }}>
                      {item[_item.key]}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="displayFlex tableTr" key={index}>
                  <div
                    className="tableTitle captionBold"
                    style={{
                      width: '10%',
                      flex: 'none',
                      borderTop: 'none',
                    }}>
                    {item.htmMm2}
                  </div>
                  <div
                    className="tableTitle captionBold"
                    style={{
                      flex: 1,
                      borderTop: 'none',
                    }}>
                    {item.total}
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NtsResult_08;
